<script>
    import { createEventDispatcher } from 'svelte';
    
    let search = (localStorage.getItem("search")) ? localStorage.getItem("search"): "";

const dispatch = createEventDispatcher();

    let onSearch = function(){
        localStorage.setItem("search", search);
        console.log(search);
        dispatch('change', { search: search });
    }
</script>

<div class="col-md-3 ">
    <input  class="form-control" type="search" placeholder="Search" on:change={onSearch} bind:value={search}>
</div>
